import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { BehaviorSubject, Subject } from 'rxjs';
import { delay, skip, switchMap, takeUntil, tap } from 'rxjs/operators';
import { LgvUserService } from '../../core/services/lgv-user.service';
import { LgvModel } from '../../data-models/longevity.model';

@Component({
    selector: 'lus-agent-search',
    templateUrl: './agent-search.component.html',
    styleUrls: ['./agent-search.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgentSearchComponent implements OnInit, OnDestroy {
    @Output() OnAgentSelected = new EventEmitter<any>();
    @Input() SelectedCompany: string = '';
    @Input() SelectedOrganization: string = '';
    @Input() label?: string = 'Agent Filter';

    _Agents: LgvModel.UserDTO[] = [];
    Agents$ = new BehaviorSubject(this._Agents);
    _form = new UntypedFormControl();
    IsLoading: boolean = false;
    IsLoading$ = new BehaviorSubject(this.IsLoading);
    onDestroy$ = new Subject();

    constructor(public LgvUserSvc: LgvUserService) { }

    ngOnInit() {
        this._form
            .valueChanges
            .pipe(
                tap(() => this.IsLoading$.next(true)),
                tap(txtSearch => { if (!txtSearch) { this.OnAgentSelected.emit('') } }),
                switchMap(txtSearch => this.LgvUserSvc.SearchWebServiceUsersByCompany(
                    !txtSearch ? '' : `${txtSearch}`,
                    !this.SelectedCompany ? '' : `${this.SelectedCompany}`,
                    !this.SelectedOrganization ? '' : `${this.SelectedOrganization}`
                )
                ),
                delay(600),
                tap(() => {
                    this.IsLoading$.next(false);
                }),
                takeUntil(this.onDestroy$)
            ).subscribe(x => {
                this.Agents$.next(x.value);
            });
    }

    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }

    selectAgent(user: LgvModel.UserDTO) {
        this.OnAgentSelected.emit(user);
    }
    displayFn(agent: LgvModel.UserDTO) {
        if (!!agent) { return `${agent?.firstName} ${agent?.lastName}`; }
    }

    reset() {
        if (this._form.value) {
            this._form.setValue('');
            this.Agents$.next([]);
        }
    }

}
